import React from "react";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";

import Common_Banner_2 from "../common_components/common_banner_2/Common_Banner_2";

const Terms_Conditions = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Terms & Conditions", link: "", isActive: true },
  ];

  return (
    <section className="Privacy_Policy">
      <Common_Banner_2
        imgSrc={"/assets/images/privacy_policy/banner.png"}
        title_text="Terms & Conditions"
        breadcrumbs={breadcrumbs}
      />

      <div className="container">
        <div className="info_main_div">
          <p className="descn_text">
            Welcome to Tech Interiors and Designers. By accessing or using our
            website and services, you agree to comply with and be bound by the
            following Terms & Conditions. Please read them carefully before
            proceeding.
          </p>

          <p className="title_text">1. General Use</p>
          <ul className="descn_text">
            <li>
              This website provides information about our interior design,
              furniture, modular kitchen, civil work, and related services.
            </li>
            <li>
              By using this site, you agree not to misuse the content or attempt
              to disrupt its functionality.
            </li>
            <li>
              All content, including text, images, and designs, is the property
              of Tech Interiors and Designers and may not be reproduced without
              permission.
            </li>
          </ul>

       

          <p className="title_text">2. Services & Quotations</p>
          <ul className="descn_text">
            <li>
              All design consultations, quotations, and project timelines are
              shared after site visits and discussions with clients.
            </li>
            <li>
              Quotations provided are valid for a limited time and may vary
              depending on material availability and market conditions.
            </li>
            <li>
              Project timelines are estimates; while we strive to deliver on
              schedule, delays may occur due to external factors beyond our
              control.
            </li>
          </ul>

          <p className="title_text">3. Payments</p>
          <ul className="descn_text">
            <li>
              Payment terms will be mutually agreed upon and clearly mentioned
              in the quotation/contract.
            </li>
            <li>
              Delayed payments may result in project delays or additional
              charges.
            </li>
            <li>
              Advance payments are generally non-refundable once project
              execution begins, except in cases of service cancellation by us.
            </li>
          </ul>

          <p className="title_text">4. Client Responsibilities</p>
          <ul className="descn_text">
            <li>
              Clients must provide accurate information regarding their
              property, requirements, and budget.
            </li>
            <li>
              Any changes requested after final design approval may lead to
              revisions in cost and project timeline.
            </li>
            <li>
              Clients are responsible for allowing site access for our teams and
              ensuring safety during execution.
            </li>
          </ul>

          <p className="title_text">5. Warranties & Limitations</p>
          <ul className="descn_text">
            <li>
              We use branded, high-quality materials, but warranties are subject
              to manufacturers’ terms (e.g., hardware, laminates, paints).
            </li>
            <li>
              While we ensure quality workmanship, Tech Interiors and Designers
              is not liable for natural wear & tear, misuse, or damage caused by
              external factors after project handover.
            </li>
          </ul>

          <p className="title_text">6. Third-Party Links & Services</p>
          <ul className="descn_text">
            <li>
              Our website may contain links to third-party sites. We are not
              responsible for their content or services.
            </li>
            <li>
              Any third-party product warranties will be handled by their
              respective manufacturers/brands.
            </li>
          </ul>

          <p className="title_text">7. Limitation of Liability</p>
          <ul className="descn_text">
            <li>
              We make every effort to ensure accurate website information, but
              errors or omissions may occur.
            </li>
            <li>
              Tech Interiors and Designers will not be liable for indirect,
              incidental, or consequential damages arising from use of the
              website or services.
            </li>
          </ul>

          <p className="title_text">8. Privacy Policy</p>
          <p className="descn_text">
            Your use of this website is also governed by our Privacy Policy,
            which explains how we collect and safeguard your information.
          </p>

          <p className="title_text">9. Changes to Terms</p>
          <p className="descn_text">
            We reserve the right to update or modify these Terms & Conditions at
            any time. Continued use of our website or services implies
            acceptance of the revised terms.
          </p>

          <p className="title_text">10. Contact Us</p>
          <p className="descn_text">
            For any queries about these Terms & Conditions, please contact:
          </p>
          <ul className="descn_text">
            <li> Email: techinteriorsanddesigners@gmail.com</li>
            <li>Phone: 9767297324 / 9822502659</li>
            <li> Address: Pune, Maharashtra</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Terms_Conditions;
